const mutations = {
  getPower (state, power) {
    state.power = power
  },
  setLoading(state, isLoading) {
    // console.log(isLoading);
    state.isLoading = isLoading;
  },
  setMenuList(state, menuList) {
    state.menuList = menuList;
  }
}

export default mutations